<template>
  <div class="modal-non-active-promotion">
    <a-modal
      :visible="visible"
      :footer="null"
      :title="$t('promotion.deactivate_title')"
      @cancel="handleClose"
    >
      <div class="modal-body">
        <p>
          {{ $t('promotion.deactivate_confirm_desc') }}<br />
          <b>{{ item.promotion_name || '' }}</b>
        </p>
      </div>
      <div class="modal-footer p-0">
        <a-button @click="handleClose">
          {{ $t('utils.cancel') }}
        </a-button>
        <a-button 
          type="primary"
          :loading="loadingNonActivePromotion"
          @click="handleConfirm"
        >
          {{ $t('promotion.deactivate_btn_confirm') }}
        </a-button>
      </div>
    </a-modal>
  </div>
</template>

<script>
import {
  nonActiveShopeePromotionChannel,
  getShopeePromotionChannelDetail,
  syncSingleShopeePromotionChannel,
  getShopeeSyncProcessStatus,
} from '@/api/channels/shopee'

export default {
  name: 'ModalNonActivePromotion',
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    item: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      loadingNonActivePromotion: false,
      loadingFetchPromotionChannelDetail: false,
      detailPromotion: {},
      isElligibleForNonActive: false,
      alreadySyncBeforeNonActive: false,
    }
  },
  methods: {
    handleClose() {
      this.$emit('close')
    },
    async handleSingleSyncPromotion() {
      try {
        this.loadingFetchPromotionChannelDetail = true
        const { data } = await syncSingleShopeePromotionChannel({
          channel_id: this.$route.params.id,
          promotion_id: this.item.promotion_id,
          business_id: this.$route.query.business_id,
        })
        if (data?.data?.sync_status?.toUpperCase() === 'ON_PROCESS') {
          setTimeout(() => {
            this.actionCheckProgressSync(data?.data?.request_id)
          }, 2000)
        } else if (data?.data?.sync_status?.toUpperCase() === 'COMPLETED') {
          this.actionSuccessSync()
        }
      } catch (error) {
        let errorMessages = this.$t('promotion.sync_failed')
        console.error('Error syncing promotion channel:', error)
        if (error.response?.data?.message) {
          errorMessages = error.response.data.message
        }
        this.$notification.destroy()
        this.$notification.error({
          message: errorMessages,
        })
        return false
      }
    },
    async actionCheckProgressSync(request_id) {
      try {
        const { data } = await getShopeeSyncProcessStatus({
          business_id: this.$route.query.business_id,
          channel_id: this.$route.params.id,
          request_id,
        })
        if (data?.data?.toUpperCase() === 'ON_PROCESS') {
          setTimeout(() => {
            this.actionCheckProgressSync(request_id)
          }, 5000)
        } else if (data?.data?.toUpperCase() === 'COMPLETED') {
          this.actionSuccessSync()
        }
      } catch (error) {
        console.error('Error syncing promotion channel:', error)
        setTimeout(() => {
          this.actionCheckProgressSync(request_id)
        }, 5000)
      }
    },
    actionSuccessSync() {
      this.fetchPromotionChannelDetail()
    },
    async fetchPromotionChannelDetail() {
      try { 
        const { data } = await getShopeePromotionChannelDetail({
          channel_id: this.$route.params.id,
          business_id: this.businessId,
          promotion_id: this.item.promotion_id,
        })
        if (data?.data?.promotion_id && data?.data?.status?.toLowerCase() === 'ongoing') {
          this.isElligibleForNonActive = true
          this.alreadySyncBeforeNonActive = true
          this.handleConfirm()
        } else {
          this.$notification.destroy()
          this.$notification.success({
            message: this.$t('promotion.deactivate_success'),
          })
          this.page = 1
          this.$emit('refetchPromotionChannelList')
          this.handleClose()
        }
      } catch (error) {
        console.error(error)
        this.$notification.error({
          message: this.$t('promotion.failed_fetch_detail'),
        })
      } finally {
        this.loadingFetchPromotionChannelDetail = false
      }
    },
    async handleConfirm() {
      const waitMsg = this.$t('promotion.deactivate_wait_msg')
      const promoName = this.item.promotion_name
      this.$notification.destroy()
      this.$notification.info({
        message: () => {
          return (
            <div>
              {waitMsg} <b>{promoName}</b>
            </div>
          )
        },
        duration: 0,
        icon: <a-icon type="loading" spin />,
      })
      this.$emit('confirm')
      if (this.alreadySyncBeforeNonActive) {
        try {
          await nonActiveShopeePromotionChannel({
            business_id: this.$route.query.business_id,
            channel_id: this.$route.params.id,
            promotion_id: this.item.promotion_id,
          })
          setTimeout(() => {
            this.$notification.destroy()
            this.$notification.success({
              message: this.$t('promotion.deactivate_success'),
            })
            this.page = 1
            this.$emit('refetchPromotionChannelList')
          }, 1000)
        } catch (error) {
          let errorMessages = this.$t('promotion.deactivate_failed')
          console.error('Error non-activating promotion channel:', error)
          if (error.response?.data?.message) {
            errorMessages = error.response.data.message
          }
          this.$notification.destroy()
          this.$notification.error({
            message: errorMessages,
          })
        } finally {
          this.loadingNonActivePromotion = false
          this.handleClose()
        }
      } else {
        this.handleSingleSyncPromotion()
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.modal-non-active-promotion {
  .modal-body {
    text-align: center;
    padding: 2rem;
  }
  
  .modal-footer {
    display: flex;
    justify-content: center;
    gap: 1rem;
    margin-top: 1.5rem;
    padding: 0;
  }
}
</style>
